import React from "react";
import PropTypes from "prop-types";
import { variantFields } from "../helpers";
import { displayVarsomePremiumLogo } from "../../../../../../common/helpers/helpers";
import AmpColumn from "./AmpColumn";
import Expander from "../../../../../../components/Expander";
import DrugsColumn from "./DrugsColumn";
import InformationColumn from "./InformationColumn";
import AssertionColumn from "./AssertionColumn";
import HelperText from "../../../../../../components/atoms/HelperText";

const AssertionDetailsTable = ({ assertionDetails, variant, variantUrl }) => {
  if (assertionDetails && assertionDetails.length > 0) {
    return (
      <div className="varsome-inner-container">
        <h5>Assertion Details</h5>
        <table className="varsome-table">
          <thead>
            <tr>
              {variantFields.map(({ title, key, width }) => {
                return (
                  <th
                    className="tw-overflow-wrap-break-word"
                    key={key}
                    width={width}
                  >
                    {title}
                    <HelperText fieldDescriptionKey={title} />
                    {key === "drugs" ? displayVarsomePremiumLogo(false) : ""}
                  </th>
                );
              })}
            </tr>
          </thead>
          <Expander
            showMore="10"
            component="tbody"
            columns={variantFields.length}
          >
            {assertionDetails.map((item, id) => {
              const {
                drugs,
                assertion_civic_url: assertionUrl,
                assertion_type: assertionType,
                assertion_description: assertionDescription,
                assertion_direction: assertionDirection,
                assertion_summary: assertionSummary,
                fda_companion_test: fdaTest,
                regulatory_approval: approval,
                evidence_item_ids: evidenceIds,
              } = item;
              return (
                <tr key={`row${id}`}>
                  <td key={`clinical-significance-${id}`}>
                    {item.clinical_significance || "-"}
                  </td>
                  <td key={`amp-category-${id}`}>
                    <AmpColumn amp={item.amp_category} />
                  </td>
                  <td key={`assertion-type-${id}`}>
                    <AssertionColumn
                      assertionUrl={assertionUrl}
                      assertionType={assertionType}
                      assertionDirection={assertionDirection}
                    />
                  </td>
                  <td key={`disease-${id}`}>{item.disease || "-"}</td>
                  <td key={`information-${id}`}>
                    <InformationColumn
                      variant={variant}
                      variantUrl={variantUrl}
                      fdaTest={fdaTest}
                      approval={approval}
                      evidenceIds={evidenceIds}
                    />
                  </td>
                  <td key={`drugs-${id}`}>
                    <DrugsColumn
                      drugs={drugs}
                      assertionDescription={assertionDescription}
                      assertionSummary={assertionSummary}
                    />
                  </td>
                </tr>
              );
            })}
          </Expander>
        </table>
      </div>
    );
  }

  return null;
};

AssertionDetailsTable.propTypes = {
  assertionDetails: PropTypes.arrayOf(
    PropTypes.shape({
      amp_category: PropTypes.string,
      assertion_civic_url: PropTypes.string,
      assertion_description: PropTypes.string,
      assertion_direction: PropTypes.string,
      assertion_id: PropTypes.string,
      assertion_summary: PropTypes.string,
      assertion_type: PropTypes.string,
      clinical_significance: PropTypes.string,
      disease: PropTypes.string,
      gene: PropTypes.string,
      doid: PropTypes.string,
      drugs: PropTypes.arrayOf(PropTypes.string),
      normalized_drug: PropTypes.arrayOf(PropTypes.string),
      evidence_item_ids: PropTypes.arrayOf(PropTypes.string),
      fda_companion_test: PropTypes.bool,
      nccn_guideline: PropTypes.string,
      nccn_guideline_version: PropTypes.string,
      regulatory_approval: PropTypes.bool,
    })
  ),
  variant: PropTypes.string,
  variantUrl: PropTypes.string,
};

AssertionDetailsTable.defaultProps = {
  assertionDetails: null,
  variant: "",
  variantUrl: "",
};

export default AssertionDetailsTable;
